






































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CircleArrow from '@/componentsV2/atoms/CircleArrow/CircleArrow.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import { SocialRewardCampaign } from '@/models/social-rewards';

export type SocialInteractionsCampaignDataProps = {
  coins: number;
  rewarded: number;
  active: boolean;
};

@Component({
  components: {
    Typography,
    FilledButton,
    CircleArrow,
    Checkbox
  }
})
export default class SocialInteractions extends Vue {
  @Prop({ default: '' }) readonly title!: string;
  @Prop({ default: '' }) readonly description!: string;
  @Prop() readonly campaignData?: SocialRewardCampaign;

  changed(event: SocialRewardCampaign) {
    this.$emit('changed', {
      ...event,
      status: event.status === 'active' ? 'inactive' : 'active'
    });
  }
}
